import { useEffect } from "react";
export default function useExternalElementClick(callback, options) {
  const {
    ignoreElements,
    targetComponentRef,
    ignoreOverlays
  } = options;
  useEffect(() => {
    function onClickExternal(event) {
      let clickIsInIgnoredElement, clickIsInOverlay;
      const elementsToIgnore = [].slice.call(document.querySelectorAll(ignoreElements));
      elementsToIgnore.push(targetComponentRef?.current);
      clickIsInIgnoredElement = elementsToIgnore.some(elem => {
        return elem && elem.contains(event.target);
      });
      if (ignoreOverlays) {
        clickIsInOverlay = event.target.getAttribute('data-automation') === 'overlay-container' || event.target.querySelector('[data-automation="overlay-container"]') instanceof HTMLElement || event.target.closest('[data-automation="overlay-container"]') instanceof HTMLElement;
      }
      if (!clickIsInIgnoredElement && !(ignoreOverlays && clickIsInOverlay)) {
        callback(event);
      }
    }
    document.addEventListener('click', onClickExternal);
    return () => {
      document.removeEventListener('click', onClickExternal);
    };
  }, [targetComponentRef]);
}